<div class="admin" [class.d-flex]="showSidebar" [class.closed-sidebar]="mobileSidebar">
    <div class="sidebar"  *ngIf="showSidebar">
        <div class="logo d-flex align-items-center justify-contet-between">
            <a>
                <img src="../../../assets/images/MC-white.svg">
            </a>
            <div class="slogan">
                <span class="slogan-ar">
                    مركز الامتياز التجاري
                </span>
                <span class="slogan-en">
                    Franchise Center
                </span>
            </div>
        </div>
        <app-sidebar></app-sidebar>
    </div>
    <div [class.admin-content]="showSidebar">
        <div [class.admin-content-main]="showSidebar">
            <button class="btn btn-lg btn-green d-lg-none d-md-block" (click)="toggleSidebar()"><i width="20" class="fa-solid fa-bars"></i></button>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>